import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';
import 'lib-flexible/flexible';

// vue-resource安装
import VueResource from 'vue-resource';

// clipboard安装
import clipboard from 'clipboard';

// mint-ui安装 和 样式导入
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';

// ElementUI安装 和 样式导入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 每个子页面添加标题
import VueWechatTitle from 'vue-wechat-title';

// animate动画库导入
import animated from 'animate.css';

import echarts from 'echarts/dist/echarts.js';

// 引入过滤器名称缩写
import * as filters from './components/FiltersName/index.js';

// 导入初始css
import './../src/assets/css/reset.min.css';

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.use(VueResource);
Vue.prototype.clipboard = clipboard;
Vue.use(Mint);
Vue.use(ElementUI);
Vue.use(VueWechatTitle);
Vue.use(animated);
Vue.prototype.$echarts = echarts;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js